/**
 * Possible user roles
 */
export enum UserRole {
  Maintainer = 'Maintainer',
  Reporter = 'Reporter',
  Viewer = 'Viewer',
  Patient = 'Patient',
}
